import { useMutation, useQueryClient } from '@tanstack/react-query';

import backendService from '../services/backendService';
import {
  PromptResourceMap,
  PromptSingleTestCaseResult,
} from '../services/backendService/types';
import { fromGenericMiltiTestCaseResultToSpecificTestCaseResult } from '../utils/aiGeneratorUtils';
import { DesignerUIStateActions, useDesignerUIContext } from './useDesignerUIState';

export const useGenerateExampleAnswers = (presentationId: string, slideId: string) => {
  const client = useQueryClient();
  const dispatch = useDesignerUIContext(context => context.dispatch);
  const { mutate: generate, data, isLoading } = useMutation(
    ['generateExamples'],
    backendService.instance.generatorPlugin.generateExampleAnswers,
    {
      onSuccess: (data: PromptResourceMap, { prompt }) => {
        const updatedDataWithUniqueIds = fromGenericMiltiTestCaseResultToSpecificTestCaseResult(
          data,
          slideId,
        );
        const exampleStudentResponse: PromptSingleTestCaseResult = {
          ['example-student-resonse.prompt.' + slideId]: {
            type: 'openAi',
            value: prompt,
            id: `example-student-resonse.prompt.${slideId}`,
          },
        };
        // Sync with the designer state
        dispatch({
          type: DesignerUIStateActions.updatePromptDependentInputsBulk,
          payload: Object.values({
            ...updatedDataWithUniqueIds,
            ...exampleStudentResponse,
          }),
        });

        // Persist to react query so that it can be restored on page refresh
        client.setQueryData(
          ['persist', 'prompt-inputs', presentationId],
          (existing: PromptSingleTestCaseResult | undefined) => {
            const exampleStudentResponse: PromptSingleTestCaseResult = {
              ['example-student-resonse.prompt.' + slideId]: {
                type: 'openAi',
                value: prompt,
                id: `example-student-resonse.prompt.${slideId}`,
              },
            };
            if (!existing) {
              return { ...updatedDataWithUniqueIds, ...exampleStudentResponse };
            }
            return {
              ...existing,
              ...updatedDataWithUniqueIds,
              ...exampleStudentResponse,
            };
          },
        );
      },
    },
  );

  return {
    generate,
    data,
    isLoading,
  };
};
